import { MoreHorizontalIcon, PencilIcon, TrashIcon } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import {
  Menu,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
} from "@/components/ui/menu";
import type { TSubjectDetail } from "@/lib/types";
import { SubjectEditDialog } from "./SubjectEditDialog";

export function SubjectDropdown({ subject }: { subject: TSubjectDetail }) {
  const [editOpen, setEditOpen] = React.useState(false);

  return (
    <>
      <MenuTrigger>
        <Button size="icon" variant="ghost">
          <MoreHorizontalIcon data-slot="icon" />
        </Button>
        <Menu aria-label="Subject actions">
          <MenuItem
            onAction={() => {
              setEditOpen(true);
            }}
          >
            <PencilIcon data-slot="icon" />
            Edit
          </MenuItem>

          <MenuSeparator />
          <MenuItem isDisabled isDanger>
            <TrashIcon data-slot="icon" />
            Delete
          </MenuItem>
        </Menu>
      </MenuTrigger>
      <SubjectEditDialog
        subject={subject}
        open={editOpen}
        onOpenChange={setEditOpen}
      />
    </>
  );
}
